let currencyCode = $('#CurrencySelector-desktop-header').attr('value');
function formatPrice(price) {
    var formattedPrice = (price / 100).toFixed(2); // Convert cents to dollars and fix to 2 decimal places
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currencyCode // Change 'USD' to your desired currency code
      }).format(formattedPrice);
    }
 // Function to generate HTML for a cart item
  function generateCartItemHTML(item) {
    // Create HTML for the item using the provided item object
    // Extract properties from the item object
    var propertiesHTML = '';
    for (var prop in item.properties) {
      if (item.properties.hasOwnProperty(prop) && item.properties[prop]) {
        propertiesHTML += `<p><strong>${prop}:</strong> ${item.properties[prop]}</p>`;
      }
    }
    // Get the image URL
      var imageUrl = item.image;
      
      // Split the URL into parts using the "." as a delimiter
      var parts = imageUrl.split(".");
      
      // Get the file extension
      var extension = parts.pop();
      
      // Append "_400x" before the extension
      var resizedImageUrl = parts.join(".") + "_200x." + extension;
    var html = `
    <div class="cdk_cart_item" key-id="${item.key}">
      <div class="cdk_cart_inner">
        <div class="image_box">
          <a href="${ item.url }">
          <img src="${resizedImageUrl}" />
          </a>
        </div>
        <div class="content_box">
          <p class="cart_title"><a href="${ item.url }">${item.title}</a></p>
          <p class="cart_price">${theme.Shopify.formatMoney(item.final_price, theme.moneyFormat)}</p>
          <div class="cart-properties">${propertiesHTML}</div>
          <div class="cart_item_control">
            <div class="quantity-control">
              <span class="decrease-quantity-btn">-</span>
              <input type="text" class="item-quantity" value="${item.quantity}" />
              <span class="increase-quantity-btn">+</span>
            </div>
            <span class="cdk_remove">
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17"><path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></svg>
            <span class="tiny-text">remove</span>
            </span>
          </div>
        </div>
      </div>
    </div>`;
    return html;
  }
  function updateMiniCart(){
  $.ajax({
    type: "GET", 
    url: '/',
    dataType: 'html',

    success: function(data) {
      var miniCartHead = $(data).find('#CartDrawer').find('.drawer_shipping_bar').html(); 
      console.log('miniCartHead::'+miniCartHead);
      $('#CartDrawer .drawer_shipping_bar').html(miniCartHead);  
    }
  })
}
function updateCartItemCount(keyId) {
     var keysInUI = $('.cdk_cart_item').map(function() {
      return $(this).attr('key-id');
    }).get();
     
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(cartData) {
        var itemCount = cartData.item_count;
        var cartSubTotal = cartData.original_total_price; // Assuming total price is in the cart data
        var cartDisocunt = cartData.total_discount; // Assuming total price is in the cart data
        var cartTotal = cartData.total_price; // Assuming total price is in the cart data
        var cartLength = cartData.items.length;
        
        // Get the number of items in the cart
        var numberOfItems = $('.cdk_cart_item').length; 

        // Initialize a variable to store the total sum
        var totalSum = 0;
        $('.cdk_cart_item input.item-quantity').each(function() {
            var quantity = parseFloat($(this).val());
            totalSum += quantity;
        });
        // console.log("Number of items in the cart:", numberOfItems);
        // console.log('cartLength::'+cartLength);
        // console.log('itemCount::'+itemCount);
        // console.log('totalSum::'+totalSum);

        if (cartLength != numberOfItems) {
       
           $('.cdk_cart_items_main').empty(); // Clear existing cart items

            for (var i = 0; i < cartData.items.length; i++) {
              var newItemHTML = generateCartItemHTML(cartData.items[i]);
              $('.cdk_cart_items_main').append(newItemHTML);
            }
        } else if (itemCount != totalSum) {
       
           $('.cdk_cart_items_main').empty(); // Clear existing cart items

            for (var i = 0; i < cartData.items.length; i++) {
              var newItemHTML = generateCartItemHTML(cartData.items[i]);
              $('.cdk_cart_items_main').append(newItemHTML);
            }
        } 
        if (itemCount >= 100) {
          $('.header-cart__count').text('99+');
        } else {
          $('.header-cart__count').text(itemCount);
        }
        if(cartSubTotal != cartTotal){
          $('.cdk_cart_subtotal').text(theme.Shopify.formatMoney(cartData.original_total_price, theme.moneyFormat));  
          $('.cdk_cart_footer .cdk_cart_footer_item.cart_sub_total').show();
        }else{
          $('.cdk_cart_subtotal').text(theme.Shopify.formatMoney(cartData.original_total_price, theme.moneyFormat));
          $('.cdk_cart_footer .cdk_cart_footer_item.cart_sub_total').hide();
        }
        
        
        if(cartDisocunt != '0'){
          $('.cdk_cart_disocunt').text('-'+ theme.Shopify.formatMoney(cartData.total_discount, theme.moneyFormat) );
          $('.cdk_cart_footer .cdk_cart_footer_item.cart_discount').show();
        }else{
          $('.cdk_cart_disocunt').text('-'+ theme.Shopify.formatMoney(cartData.total_discount, theme.moneyFormat) );
          $('.cdk_cart_footer .cdk_cart_footer_item.cart_discount').hide();
        }
        
        if(cartTotal != '0'){
          $('.cdk_cart_total').text(theme.Shopify.formatMoney(cartData.total_price, theme.moneyFormat));
          $('.cdk_cart_payment-info strong').text(theme.Shopify.formatMoney(cartData.total_price / 4, theme.moneyFormat));
          $('.cdk_cart_footer .cdk_cart_footer_item.cart_total').show();
          $('.drawer__footer').show();
          $('.drawer__inner-empty').hide();
        }else{
          $('.cdk_cart_total').text(theme.Shopify.formatMoney(cartData.total_price, theme.moneyFormat));
          $('.cdk_cart_footer .cdk_cart_footer_item.cart_total').hide();
          $('.drawer__footer').hide();
          $('.drawer__inner-empty').show();
          $('.cdesk-cart-drawer').addClass('is-empty');
        }
        
        
        $('.cdk_cart_item').removeClass('loading');
        
        $('body,html').addClass('overflow-hidden');
      },
      error: function(XMLHttpRequest, textStatus, errorThrown) {
        console.error('Error fetching cart data:', textStatus, errorThrown);
      }
    });
  }
// Function to update cart item on Shopify
    function updateCartItem(keyId, newQuantity) {
      var data = {
        updates: {}
      };
      data.updates[keyId] = newQuantity;

      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function(cart) {
          // Handle success if needed
          updateMiniCart();
          updateCartItemCount();
        },
        error: function(xhr, status, error) {
          // Handle error if needed
        }
      });
    }
function ajaxAddToCartProduct(currentThis, dynamicData) {
  $.ajax({
    url: "/cart/add.js",
    type: "POST",
    data: { items: dynamicData },
    dataType: "json",
    success: function (data) {
      updateCartItem();
      $('.cdk-product-slider, .product_item').removeClass('disable');
      $('body').addClass('overflow-hidden');
      $('.cdesk-cart-drawer').removeClass('is-empty');
      $('.cdesk-cart-drawer').addClass('active'); 
      $('.cdk-product-block-btn').find('.btn_text').removeClass('product-loading');
      $('.cdk-product-block-btn').find('.loading-overlay__spinner').addClass('hidden');
      
    },
    error: function (jqXHR, textStatus, errorThrown) {
      if (jqXHR.status == 400) {
        alert(jqXHR.responseJSON.message);
      }
      if (jqXHR.status == 422) {
        alert(jqXHR.responseJSON.description);
      }
    },
  });
}
function cartSlider(){
  $('.cart-drawer__collection').slick({
  dots: true,
  arrows: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
}
// cart darwer slider
$(document).ready(function(){
    $('.font-option').click(function(){
        $('.font-option').removeClass('selected');
        $(this).addClass('selected');
        var $fabric = $(this).attr(value);
        var $fabricChoice = $(this).parent().parent().parent().find('.fabric-choice');
        $fabricChoice.text($fabric);
    })

    $('.fabric-option__secondary').click(function(){
        $('.fabric-option__secondary').removeClass('selected');
        $(this).addClass('selected');
        var $fabric = $(this).val()
        var $fabricChoice = $(this).parent().parent().parent().find('.fabric-choice');
        $fabricChoice.text($fabric);
    });

    // Show & hide name field
    // var $fieldHeight = $('.product-customiser__field-name').height();
    // console.log($fieldHeight);
    // $('.product-customiser__field-name').css('max-height', '0px');
    $('#include-personalised-name').change(function(){
      if(this.value == 'Yes') {
        $('.product-customiser__field-name').show();
      } else {
        $('.product-customiser__field-name').hide();
      }
    })

    // Accordions
    $('.accordion--toggle').click(function(){
        $(this).parent().find('.accordion--content').toggleClass('is--closed');
    });

    $('.fabric-selector').click(function(){
        fabricValue = $(this).val();
        $(this).parent().parent().addClass('is--closed')
        $(this).parent().parent().parent().find('.accordion--toggle > span').html(fabricValue);
    });

    $('.fabric-option__secondary').click(function(){
        $(this).parent().parent().addClass('is--closed')
    });

    $('.accordion--content').each(function(){
        var $height = $(this).height();
        $(this).css('height', $height);
    });

    // Option Modals
    $('.product-customiser__option-toggle').on('click', function(e){
        e.preventDefault();
        $('body').css('overflow', 'hidden');
        var opensModal = $(this).attr('data-opens');
        $(`[data-modal='${opensModal}']`).removeClass('hide');
    });

    $(document).on('click', '.option-modal__close', function(e){
        e.preventDefault();
        $('body').css('overflow', 'scroll');
        $(this).parent().closest('.option-modal').addClass('hide');
    });

    $(document).on('click', '.option-modal__option', function(e){
        $('body').css('overflow', 'scroll');
        $(this).parent().closest('.option-modal').addClass('hide');

        // set toggle image to selection
        var image = $(this).find('img').attr('src');
        var controls = $(this).attr('data-controls');
        $(`[data-imagefrom='${controls}']`).attr('src', image);
     	// console.log(image);
    });

    // preview text
    $('#preview-text').on('keypress', function (event) {
        var textarea = $(this),
            text = textarea.val(),
            numberOfLines = (text.match(/\n/g) || []).length + 1,
            maxRows = parseInt(textarea.attr('rows'));

        if (event.which === 13 && numberOfLines === maxRows ) {
            return false;
        }
    });
  $(document).on('click','.drawer__close, .cart-drawer__overlay', function(event){
    event.stopPropagation();
    event.preventDefault();
    $('.cdesk-cart-drawer').removeClass('active');
    $('body,html').removeClass('overflow-hidden');
    // $('.cart-drawer__collection').slick('unslick');
    // $('.cdesk-cart-drawer').removeClass('active');
  })
  $(document).on('click','.header-cart:not(.no_cart_drawer)', function(p){
    // p.preventDefault();
    $('body,html').addClass('overflow-hidden');
    $('.cdesk-cart-drawer').addClass('active');
    
    
  })
  $(document).mouseup(function(ee){
    ee.preventDefault();
    ee.stopPropagation();
    
      var container = $(".cdesk-cart-drawer .drawer__inner");
   
      // If the target of the click isn't the container
      if(!container.is(ee.target) && container.has(ee.target).length === 0){
        $('.cdesk-cart-drawer').removeClass('active');
        $('body,html').removeClass('overflow-hidden');
      }
  });
  
// CART DRAWER


    // Increase quantity button
    $(document).on('click', '.increase-quantity-btn', function() {
      var $cartItem = $(this).closest('.cdk_cart_item');
      var keyId = $cartItem.attr('key-id');
      var $quantity = $cartItem.find('.item-quantity');
      var newQuantity = parseInt($quantity.val()) + 1;
      $cartItem.addClass('loading');
      updateCartItem(keyId, newQuantity);
      $quantity.val(newQuantity);
    });

    // Decrease quantity button
    $(document).on('click', '.decrease-quantity-btn', function() {
      var $cartItem = $(this).closest('.cdk_cart_item');
      var keyId = $cartItem.attr('key-id');
      var $quantity = $cartItem.find('.item-quantity');
      var newQuantity = parseInt($quantity.val()) - 1;
      $cartItem.addClass('loading');
      
      if (newQuantity >= 0) {
        updateCartItem(keyId, newQuantity);
        $quantity.val(newQuantity);
      }
      if (newQuantity == 0) {
        $cartItem.slideDown().remove();
      }
    });

   // Remove quantity button
    $(document).on('click', '.cdk_remove', function() {
      var $cartItem = $(this).closest('.cdk_cart_item');
      var keyId = $cartItem.attr('key-id'); 
      var newQuantity = 0;
      $cartItem.addClass('loading');
      
      updateCartItem(keyId, newQuantity);
      // $cartItem.slideDown().remove();
      setTimeout(function() {
        $cartItem.slideDown().remove();
      }, 1000);
    });
  // $(document).on('submit','.ajax-product-form', function(event) {
  //     event.preventDefault(); 
  //   var form = $(this);
  //   var actionUrl = form.attr('action');
    
  //   $.ajax({
  //       type: "POST",
  //       url: actionUrl,
  //       data: form.serialize(), // serializes the form's elements.
  //       success: function(data) {
  //         updateCartItem();
  //         setTimeout(function () {
  //         $('body').addClass('overflow-hidden');
  //         $('.cdesk-cart-drawer').addClass('active').removeClass('is-empty');
  //         },1000)
  //       }
  //   });
  // });

  $(document).on('click','.product__info-wrapper button.product-form__submit',function(){ 
      var currentThis = $(this);
      var updateItems = [];
      var variantId = $(this).parents('.product-form').find('form input[name="id"]').attr("value");
      var quantity = $(this).parents('.product__info-container').find('.quantity .quantity__input').val();
      var selling_plan = $(this).attr("data-sellingplan");
      var orderType = $(this).attr("data-type"); 
      var orderFor = $(this).parents('.product-card-wrapper').find('.orderforBlock .orderforinput').val();
        //console.log('selling_plan::'+selling_plan);
        updateItems.push({ "id": variantId, "quantity": quantity });
      
      ajaxAddToCartProduct(currentThis,updateItems);currentThis.addClass('is-loading');currentThis.find('.loading-overlay__spinner').removeClass('hidden');
      
  });
  
 $(document).on('click','.swatches-block .swatches-item-box .swatches-option', function () {
    var OptionName = $(this).attr('data-value');
    $(this).parents('.swatches-item-box').find('.swatches-option').removeClass('selected');
    $(this).addClass('selected');
    $(this).parents('.swatches-block').find('select').val(OptionName).change();
    //console.log("OptionName::"+OptionName);
  })
  $(document).on('change','.swatches-block select', function () {
    var FinalValue = '';
    $('.swatches-block').each(function() {
      var selectVal = $(this).find('select').val();
      FinalValue += selectVal+' / ';
      // console.log('selectVal::'+selectVal);
    });
    var newstr = FinalValue.substring(0, FinalValue.length - 3);
      // console.log('newstr::'+newstr);
    var optionName_Selector = $(this).parents('.product-swatches').find('.product-form__master-select option[check-data-sku="'+newstr+'"]')
    var optionName_val = optionName_Selector.val();

    var Selected_price = optionName_Selector.attr('data-price');
    var Selected_availability = optionName_Selector.attr('data-varaint-availability');
    var Selected_variant = optionName_Selector.attr('value');
    $(this).parents('.product-swatches').find('.product-form__master-select').val(optionName_val).change();
      $(this).parents('.related_product_item').find('.related_product__price').text(Selected_price);

    if(Selected_availability == 'true'){
      $(this).parents('.related_product_item').find('.fbt_btn_add').attr('data-id',Selected_variant);
      $(this).parents('.related_product_item').find('.fbt_btn_add').attr('data-variant',Selected_variant);
      $(this).parents('.related_product_item').find('.fbt_btn_add span').text('Add');
    }else{
      $(this).parents('.related_product_item').find('.fbt_btn_add').attr('data-id',Selected_variant);
      $(this).parents('.related_product_item').find('.fbt_btn_add').attr('data-variant',Selected_variant);
      $(this).parents('.related_product_item').find('.fbt_btn_add span').text('Soldout');
    }
  })
  // $(document).on('click', '.faq-ques', function(){
  //    $(this).parents('.content').siblings('.content').find('.faq-content .faq-ques').removeClass('active');
  //    $(this).parents('.content').siblings('.content').find('.faq-content .faq-ans').slideUp();
  //    $(this).toggleClass('active');
  //    $(this).parents('.content').find('.faq-content .faq-ans').slideToggle();
  //   });
  $(document).on('click', '.cdk-product-tab-list.content', function(){
    $(this).siblings('.content').find('.faq-content .faq-ques').removeClass('active');
    $(this).siblings('.content').find('.faq-content .faq-ans').slideUp();
    $(this).find('.faq-ques').toggleClass('active');
    $(this).find('.faq-ans').slideToggle();
});


  // $('.accordion-list > li').click(function() {
  //     if ($(this).hasClass("active")) {
  //       $(this).removeClass("active").find(".answer").slideUp();
  //     } else {
  //       $(".accordion-list > li.active .answer").slideUp();
  //       $(".accordion-list > li.active").removeClass("active");
  //       $(this).addClass("active").find(".answer").slideDown();
  //     }
  //     return false;
  //   });
})

$(document).ready(function(){
   $(document).on('click', '.cdk-product-box .read_more', function(){
      $(this).parents('.cdk-product-box').find('.half_text').hide();
      $(this).parents('.cdk-product-box').find('.full_text').show();
      $(this).hide();
      $(this).parents('.cdk-product-box').find('.read_less').show();
  });
   $(document).on('click', '.cdk-product-box .read_less', function(){
      $(this).parents('.cdk-product-box').find('.half_text').show();
      $(this).parents('.cdk-product-box').find('.full_text').hide();
      $(this).hide();
      $(this).parents('.cdk-product-box').find('.read_more').show();
  });

  // Personlised
  
  $(document).on('click', '.personlised_button', function(){
      $('.personlised_popup').show();
      $('html,body').addClass('overflow__hidden');
  });
  $(document).on('click', '.next__button .next_bt', function(){
      $('.personlised_popup .product-customiser__field.name').hide();
      $(this).parents('.next__button').hide();
      $('.personlised_popup .custom__option_modal').show();
      $(this).parents('.personlised_popup').find('.personlised_popup_content').addClass('height');
  });


  var $options = $('.personlised_popup_content .custom__option_modal .option-modal');
  var currentIndex = 0;
  var $prevButton = $('.next_previous_button .previos_bt');
  var $nextButton = $('.next_previous_button .next_bt');

  function updateButtonStates() {
        $prevButton.toggleClass('disabled', currentIndex === 0);
        $nextButton.toggleClass('disabled', currentIndex === $options.length - 1);
        $prevButton.toggleClass('active', currentIndex === $options.length - 1);
    }
  
    $options.first().addClass('active');
    updateButtonStates();
    
  $(document).on('click', '.next_previous_button .next_bt', function(){
      if (currentIndex < $options.length - 1) {
          var nextModal = $options.eq(currentIndex + 1).attr('data-modal');
          $options.eq(currentIndex).removeClass('active');
          currentIndex++;
          $options.eq(currentIndex).addClass('active');
          updateButtonStates();
          if (nextModal === "front-fabric-modal") {
              $('#view-front').trigger('click');
          } else if (nextModal === "backing-fabric-modal") {
              $('#view-back').trigger('click');
          }
      }
  });
  
  $(document).on('click',".next_previous_button .previos_bt.disabled", function(e){
      e.preventDefault();
      $(this).parents('.personlised_popup').find('.product-customiser__field.name').show();
      $(this).parents('.personlised_popup').find('.next__button').show();
      $(this).parents('.personlised_popup').find('.custom__option_modal').hide();
      $(this).parents('.personlised_popup').find('.personlised_popup_content').removeClass('height');
  });
  
  $(document).on('click','.next_previous_button .previos_bt:not(.disabled)', function(e){
      e.preventDefault();
      if (currentIndex > 0) {
          var prevModal = $options.eq(currentIndex - 1).attr('data-modal');
          $options.eq(currentIndex).removeClass('active');
          currentIndex--;
          $options.eq(currentIndex).addClass('active');
          updateButtonStates();
          if (prevModal === "front-fabric-modal") {
              $('#view-front').trigger('click');
          } else if (prevModal === "backing-fabric-modal") {
              $('#view-back').trigger('click');
          }
      }
  });

  
  $(document).on('click', '.personlised_close_bt', function(){
      $('.personlised_popup').hide();
      $('html,body').removeClass('overflow__hidden');
      $(this).parents('.personlised_popup').find('.product-customiser__field.name').show();
      $(this).parents('.personlised_popup').find('.next__button').show();
      $(this).parents('.personlised_popup').find('.custom__option_modal').hide();
      $(this).parents('.personlised_popup').find('.custom__option_modal .option-modal').removeClass('active');
      $(this).parents('.personlised_popup').find('.custom__option_modal .option-modal').first().addClass('active');
      currentIndex = 0;
      $('.next_previous_button span').removeClass('disabled');
      $('.next_previous_button .previos_bt').addClass('disabled');
      $('.next_previous_button .previos_bt').removeClass('active');
      $(this).parents('.personlised_popup').find('.personlised_popup_content').removeClass('height');
  });

  
  $(document).on('click', '.personlised_popup .add_custom .custom_add', function(){
      $(this).parents('.ajax-product-form').find('.payment-buttons button.btn').trigger('click');
      $(this).addClass('active');
      $(this).text('Adding');
      var $customAdd = $(this);
      setTimeout(function() {
        $('.personlised_popup').hide();
        $('html,body').removeClass('overflow__hidden');
        $customAdd.parents('.personlised_popup').find('.product-customiser__field.name').show();
        $customAdd.parents('.personlised_popup').find('.next__button').show();
        $customAdd.parents('.personlised_popup').find('.custom__option_modal').hide();
        $customAdd.parents('.personlised_popup').find('.custom__option_modal .option-modal').removeClass('active');
        $customAdd.parents('.personlised_popup').find('.custom__option_modal .option-modal').first().addClass('active');
        currentIndex = 0;
        $('.next_previous_button span').removeClass('disabled');
        $('.next_previous_button .previos_bt').addClass('disabled');
        $('.next_previous_button .previos_bt').removeClass('active');
        $customAdd.parents('.personlised_popup').find('.personlised_popup_content').removeClass('height');
        $customAdd.removeClass('active');
        $customAdd.text('Add to Cart');
      }, 1000);
  });
  
  $(document).on('click', '.product-customiser__option .option-modal__option', function(){
      $(this).closest('.option-modal__content').find('.product-customiser__options .product-customiser__option').removeClass('active');
      $(this).closest('.product-customiser__option').addClass('active');
  });
   $(document).on('click', '.popup_main_btn', function() {
    let popopID = $(this).attr('id');
    // console.log('popopID::'+popopID);
    $(".custom-model-main").removeClass('model-open');
    $(".custom-model-main[data-popop='"+popopID+"']").addClass('model-open');
  }); 
  $(".close-btn, .bg-overlay").click(function(){
    $(".custom-model-main").removeClass('model-open');
    $('.cdesk-cart-drawer').addClass('active');
    $('body,html').addClass('overflow-hidden');
  });
});